export default {
    source_migration_title: 'Source Migration'
};  